import { InfoLogs } from '@/constants/logs';
import { logWarn } from '@/utils/logger';

const loggedFallbacks = new Set<string>();


export const getPaymentKey = (
  methodKey: string | undefined,
  topLevelKey: string | undefined,
  source: { provider: string; paymentMethod: string }
): string | undefined => {
  if (methodKey) return methodKey;
  if (!topLevelKey) return undefined;

  const dedupeKey = `${source.provider}:${source.paymentMethod}`;
  if (!loggedFallbacks.has(dedupeKey)) {
    loggedFallbacks.add(dedupeKey);
    logWarn(InfoLogs.pspKeyTopLevelFallback, null, {
      provider: source.provider,
      paymentMethod: source.paymentMethod,
    });
  }
  return topLevelKey;
};
